import { ActionContext, ActionTree } from 'vuex';
import LagerService from '@/modules/ewerp/service/LagerService';

import { MitarbeiterArbeitszeit } from '@/modules/ewerp/models/PersonaldatenModels';

import { RootState } from '@/modules/ewerp/store';
import { useEwerpCommonStore } from '@/modules/ewerp/store/ewerpCommonStore';
import { State } from './state';

import { Mutations, MutationTypes } from './mutations';


export enum ActionTypes {
  GetMitarbeiterArbeitszeiten = 'GET_MITARBEITER_ARBEITSZEITEN',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetMitarbeiterArbeitszeiten](context: ActionArguments): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetMitarbeiterArbeitszeiten]({ commit }: ActionArguments) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.mitarbeiterArbeitszeitenLoading = true;
    status.mitarbeiterArbeitszeitenErrorMsg = '';
    commonStore.setStatus(status);

    return LagerService.getCurrentlyWorkingMitarbeiter()
      .then((res) => {
        const data: Array<MitarbeiterArbeitszeit> = res.data;
        commit(MutationTypes.SetMitarbeiterArbeitszeit, data);
      })
      .catch((err) => {
        status.mitarbeiterArbeitszeitenErrorMsg = err.response.data;
        commonStore.setStatus(status);
      })
      .finally(() => {
        status.mitarbeiterArbeitszeitenLoading = false;
        commonStore.setStatus(status);
      });
  },
};
